import { isDefined } from '@utils/general'

import type { FilterOption, TimeDeadline } from '../types'
import { filterByDeadline } from '../util'

export type CustomTimeDeadlineFilter = (
  params: any,
  selectedIndex: number,
  options: FilterOption<TimeDeadline>[],
  includeDrops?: boolean
) => boolean

export const doesSiteRunoutFilterPass: CustomTimeDeadlineFilter = (params, selectedIndex, options, includeDrops) => {
  const site = params.data as Gravitate.Site
  if (!isDefined(selectedIndex)) return true
  return filterByDeadline(
    includeDrops ? site.soonest_run_out_with_drops : site.soonest_run_out,
    options[selectedIndex].value
  )
}

export const doesOrderRunoutFilterPass: CustomTimeDeadlineFilter = (params, selectedIndex, options, includeDrops) => {
  if (!isDefined(selectedIndex)) return true
  if (params?.data?.type?.toLowerCase() === 'backhaul') return false
  return filterByDeadline(params?.data?.dispatch_window_end, options[selectedIndex].value)
}
export const doesOrderNoFitFilterPass: CustomTimeDeadlineFilter = (params, selectedIndex, options) => {
  const start = params?.data?.tank_dispatch_window_start ?? params?.data?.dispatch_window_start
  if (!isDefined(selectedIndex)) return true
  return filterByDeadline(start, options[selectedIndex].value)
}

export const doesSiteNoFitFilterPass: CustomTimeDeadlineFilter = (params, selectedIndex, options) => {
  const site = params.data as Gravitate.Site
  if (!isDefined(selectedIndex)) return true
  if (isDefined(site.retain?.retain_time))
    return filterByDeadline(site.retain.retain_time, options[selectedIndex].value)

  return false
}
